export default {
  speed: 250,
  dots: true,
  arrows: false,
  slide: '.views-row',
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./Settings.Difference.js